import { useRef } from "react";
import { IoIosArrowDown } from "react-icons/io";

type IProps = {
  styles?: string;
  iconSize?: number;
  iconColor?: string;
};

export default function ToggleBtn({
  styles = "toggle-btn",
  iconSize = 16,
  iconColor = "#fff",
}: IProps) {
  const toggleRef = useRef<HTMLButtonElement>(null);
  return (
    <>
      <button
        ref={toggleRef}
        className={styles}
        onClick={(e) => {
          const classNm = e.currentTarget.className;
          const parent = e.currentTarget.closest("div.sub-head");
          const next = parent?.nextSibling as HTMLDivElement;

          if (classNm.includes("_rotate")) {
            e.currentTarget.className = "toggle-btn";
            next.hidden = false;
          }
          if (!classNm.includes("_rotate")) {
            e.currentTarget.className = "toggle-btn _rotate";
            next.hidden = true;
          }
        }}
      >
        <IoIosArrowDown size={iconSize} color={iconColor} />
      </button>
    </>
  );
}
